export default __webpack_public_path__ + "assets/images/020ba822bb272a1822f63ee0456d9054.png";